module.exports = __webpack_public_path__ + "img/PersonajeTurismo.958510c1.png";